/**
 * Target job the user typed for an ATS run. Reused on Quick Edit
 * so they do not re-enter the same role.
 */

const isBrowser = () => typeof window !== 'undefined';

const storageKey = (cvId) => `clarcv_job_${cvId}`;

/**
 * Persist the ATS job title for this CV id.
 *
 * @param {string|number} cvId
 * @param {string} job
 */
export const rememberJobPosition = (cvId, job) => {
  const id = String(cvId || '').trim();
  const value = (job || '').trim();
  if (!isBrowser() || !id || !value) return;
  try {
    window.localStorage.setItem(storageKey(id), value);
  } catch (err) {
    /* private mode / blocked storage */
  }
};

/**
 * Job title stored for this CV, or empty string.
 *
 * @param {string|number} cvId
 * @returns {string}
 */
export const recalledJobPosition = (cvId) => {
  const id = String(cvId || '').trim();
  if (!isBrowser() || !id) return '';
  try {
    return (window.localStorage.getItem(storageKey(id)) || '').trim();
  } catch (err) {
    return '';
  }
};
